
const styles = (theme) => ({
  buttons: {
    '@global': {
      button: {
        '&.positive': {
          marginRight: `${theme.spacing(1)}px !important`
        }
      }
    }
  }
})

export {
  styles
}
